module.exports = __webpack_public_path__ + "img/451027.8a4c893a.png";